import { query } from 'services/query';
import { GET_AUDIENCE_BOARD_MINI_FROM_EXCEL } from 'CONSTANTS/endpoints';

export function excelMiniParse(data) {
  return query
    .postRequest({
      url: GET_AUDIENCE_BOARD_MINI_FROM_EXCEL,
      data,
    })
    .then((data) => data);
}
